<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="groupSizes"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Gets + Sets hotel group size fields using a single select box
     */
    export default {
        name: 'ies-input-group-size',
        props: ['field', 'recordData'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                groupSizes: [
					{ text:'2-4', 	value: 'size_categories_1' },
					{ text:'5-10', 	value: 'size_categories_2' },
					{ text:'11-20', value: 'size_categories_3' },
					{ text:'21-30', value: 'size_categories_4' },
					{ text:'31-40', value: 'size_categories_5' },
					{ text:'41-50', value: 'size_categories_6' },
					{ text:'50+',	value: 'size_categories_7' },
				],
                viewValue: this.field.value,
            }
        },
        created:function() {
            this.getGroupSize();
        },
        methods: {
            getGroupSize:function(){
                axios.get('/api/hotel-group-size/' + this.recordData.hotel_key).then((response) => {
					let sizes = response.data.sizes; 
					this.viewValue = Object.keys(sizes).filter(k => sizes[k])[0] || 0;
                });
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>


